import _ from "lodash";
import PropTypes from "prop-types";
import "./pagination.scss";
// import { Link } from "react-router-dom";

const Pagination = (props) => {
  const { itemsCount, pageSize, currentPage, onPageChange, onGotoFirstPage, onGotoLastPage,isShowDetail=true } = props;
  const pagesCount = Math.ceil(itemsCount / pageSize);

  if (pagesCount <= 1) return null;
  const pages = _.range(1, pagesCount + 1);

  let start_index = 0;
  if (currentPage > 1) start_index = currentPage - 2;

  return (
    <nav>
      <div className="pagination">
        <span className={currentPage > 1?"first":""} onClick={() => {
          currentPage > 1 && onGotoFirstPage();
        }}>
          { isShowDetail?"<<First":"< Previous"}
        </span>
        <ul className="pagination">
        {pages
          .map((page) => (
            <li key={page} className={page === currentPage ? "page-item pointer active" : "page-item pointer"}>
              <button className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </button>
              {/* <a className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </a> */}
            </li>
          ))
          .slice(start_index, currentPage + 4)}{" "}
        </ul>
       <div>
          <span className={currentPage !== pagesCount?"first":""}
                onClick={() => {
                  currentPage !== pagesCount && onGotoLastPage(pagesCount);
                }}>
          {(isShowDetail?"Last>>":"Next >")}
        </span>
         {isShowDetail && (
             <span className="total-pages">{`Page ${currentPage} out of ${pagesCount}`}</span>
         )}
       </div>
      </div>
    </nav>
  );
};

Pagination.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
